import { useMutation, useQueryClient } from "@tanstack/react-query";
import { notification } from "antd";
import { ApplyJobPayloadInterface, } from "./dto";
import { db } from "../../firebase/firebase";
import { collection, addDoc, updateDoc } from "firebase/firestore";
import { QueryKeys } from "config/query-keys";
import { APPLICATION_STATUS } from "enum/job-status-type";
import cleanData from "utils/cleanPayloadForFirebase";

/**
 * Saves a job for the user in Firestore.
 */
const saveJobs = async ({ id, data, enumerator_info, isSaved }: ApplyJobPayloadInterface & { isSaved?: boolean }) => {
  try {
    const jobApplicationCollectionRef = collection(db, "applications");

    const applicationRef = await addDoc(jobApplicationCollectionRef, {
      jobId: id,
      applicant_info: enumerator_info,
      resume: data.resume || "", 
      coverLetter: data.coverLetter || "",
      status: APPLICATION_STATUS.SAVED,
      appliedAt: new Date(),
    });

    await updateDoc(applicationRef, cleanData({ id: applicationRef.id }));

    return { success: true };
  } catch (error) {
    console.error("Error applying for job:", error);
    throw error;
  }
};

/**
 * React Query hook for saving a job.
 */
export const useSaveJobs = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: saveJobs,
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: [QueryKeys.JOBS] });
      notification.success({
        message: "Saved",
        description: "Job has been successfully saved.",
      });
    },
    onError: () => {
      notification.error({
        message: "Error",
        description: "Failed to save the job.",
      });
    },
  });
};